export const TeamDescriptionCharacterLimit = 35;

export const TeamStatus = ['Public', 'Private'];

export const TeamMemberRole = ['Member', 'Lead', 'Manager'];
